import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { compare } from "bcrypt-ts";
import { HttpClient, HttpParams } from '@angular/common/http';
import { User } from '../Models/User';
import { firstValueFrom, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  standalone: false
})
export class LoginComponent {

  @Output()
  loggedInUser = new EventEmitter<User | undefined>();

  constructor(private http: HttpClient) { }

  public user: User | undefined = undefined;
  public loginError = false;


  //VS Uncomment this and comment below method to bypasslogin
  //async loginFromForm(loginForm: NgForm) {

  //  this.loggedInUser.emit({
  //    id: 1,
  //    username: "developer",
  //    firstName: "Dev",
  //    lastName: "User",
  //    email: "developer@test.com",
  //    roles: [
  //      {
  //        id: 1,
  //        code: "SystemAdministrator",
  //        displayName: "System Administrator"
  //      }
  //    ]
  //  });
  //}


  async loginFromForm(loginForm: NgForm) {

    if (loginForm.invalid) return;

    await this.login(
      loginForm.value["username"],
      loginForm.value["password"]
    );
  }


  async login(username: string, password: string) {

    this.loginError = false;

    try {

      const response = await lastValueFrom(
        this.http.post<User>('/charitycentral/login', {
          username,
          password
        })
      );

      this.user = response;
      this.loggedInUser.emit(this.user);

    } catch {
      this.loginError = true;
    }
  }


  //VS Uncomment this and comment above to bypasslogin
    //async login(username: string, password: string) {

    //  console.log("login() called");

    //  this.user = {
    //    id: 1,
    //    username: "developer",
    //    firstName: "Dev",
    //    lastName: "User",
    //    email: "developer@test.com",
    //    roles: [
    //      {
    //        id: 1,
    //        code: "SystemAdministrator",
    //        displayName: "System Administrator"
    //      }
    //    ]
    //  };

    //  console.log("Emitting user", this.user);

    //  this.loggedInUser.emit(this.user);
    //}
  }

